import React from "react";
import FlightCardBoundMobile from "./components/FlightCardBound";
import FlightCardBoundDesktop from "./components/FlightCardBound.desktop";
import Frame from "../Frame";
import useFlightCardController, { FlightCardControllerProps } from "./useFlightCard.controller";
import useFlightsWebAaSrBadgesVisibilityDesktop from "../../../utils/experiments/funnel/flights_web_aa_sr_badges_visibility_desktop";
import useFlightsWebAaSrBadgesCombinationDesktop from "../../../utils/experiments/funnel/flights_web_aa_sr_badges_combination_desktop";

const _FlightCard = (props: FlightCardControllerProps) => {
  const {
    ariaLabel,
    bigLogo,
    flight,
    forceHideLastAvailableSeats,
    handleOnClick,
    index,
    isAlternativeFareCard,
    mb,
    mt,
    ref,
    searchType
  } = useFlightCardController(props);
  const FlightCard = isAlternativeFareCard ? FlightCardBoundMobile : FlightCardBoundDesktop;

  // flights_web_aa_sr_badges_visibility_desktop - start
  const { trackOnClickVisibility } = useFlightsWebAaSrBadgesVisibilityDesktop(ref, flight);
  // flights_web_aa_sr_badges_visibility_desktop - end

  // flights_web_aa_sr_badges_combination_desktop - start
  const { trackOnClickCombination } = useFlightsWebAaSrBadgesCombinationDesktop(ref, flight);
  // flights_web_aa_sr_badges_combination_desktop - end

  return (
    <Frame
      mt={mt !== undefined ? mt : 2}
      mb={mb !== undefined ? mb : 4}
      elementRef={ref}
      attributes={{ role: "group", "aria-label": ariaLabel }}
    >
      <FlightCard
        flight={flight}
        onClick={() => {
          trackOnClickCombination();
          trackOnClickVisibility();
          handleOnClick();
        }}
        pricePerPerson
        index={index}
        bigLogo={bigLogo}
        searchType={searchType}
        forceHideLastAvailableSeats={forceHideLastAvailableSeats}
        isAlternativeFareCard={isAlternativeFareCard}
      />
    </Frame>
  );
};

const FlightCard = React.memo(_FlightCard);

export default FlightCard;
